import {Box} from '@mui/joy';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

const TIME_OPTIONS = Array.from({length: 48}, (_, index) =>
  `${String(Math.floor(index / 2)).padStart(2, '0')}:${index % 2 ? '30' : '00'}`);

function displayValue(value) {
  const text = value == null ? '' : String(value);
  // Django TimeField commonly returns seconds. This changes display only:
  // opening the control never writes a normalized value back into the form.
  return /^\d{2}:\d{2}:00$/.test(text) ? text.slice(0, 5) : text;
}

/** An explicit half-hour list, independent of the browser's time-step base. */
export default function HalfHourTimeInput({
  value = '', onChange, label = 'Время', name, id, disabled = false,
  required = false, error = false, size = 'md', sx, ...aria
}) {
  const current = displayValue(value);
  const legacy = Boolean(current && !TIME_OPTIONS.includes(current));
  return <Box sx={{position: 'relative', display: 'flex', flex: 1, minWidth: 0, ...sx}}>
    <Box component="select" id={id} name={name} value={current}
      aria-label={label} aria-invalid={error || undefined}
      title={legacy ? `Сохранённое время: ${current}` : undefined} {...aria}
      disabled={disabled} required={required}
      onChange={event => onChange?.(event.target.value)}
      sx={{
        width: '100%', minWidth: 0, minHeight: size === 'sm' ? 36 : 40,
        px: 1.5, pr: 4.5, py: 0.75, border: '1px solid',
        borderColor: error ? 'danger.outlinedBorder' : 'neutral.outlinedBorder',
        borderRadius: '10px', backgroundColor: 'background.surface', color: 'text.primary',
        appearance: 'none', font: 'inherit', fontSize: 14, cursor: disabled ? 'default' : 'pointer',
        boxShadow: 'var(--joy-shadow-xs)',
        '&:hover:not(:disabled)': {borderColor: error ? 'danger.500' : 'neutral.400'},
        '&:focus-visible': {outline: '2px solid var(--joy-palette-primary-500)', outlineOffset: 1},
        '&:disabled': {backgroundColor: 'neutral.softDisabledBg', color: 'neutral.softDisabledColor', cursor: 'not-allowed'},
        '@media (max-width: 600px)': {minHeight: 44, fontSize: 16},
      }}>
      <option value="">Не указано</option>
      {legacy && <optgroup label="Сохранённое время"><option value={current}>{current}</option></optgroup>}
      {TIME_OPTIONS.map(time => <option key={time} value={time}>{time}</option>)}
    </Box>
    <AccessTimeRoundedIcon aria-hidden="true" sx={{
      position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
      fontSize: 18, color: disabled ? 'neutral.softDisabledColor' : 'text.tertiary', pointerEvents: 'none',
    }}/>
  </Box>;
}
